import React from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import moment from 'moment'
import { Modal, Header, Form, Button, Icon } from 'semantic-ui-react'

import TitleField from '../fields/inputField'
import DateField from '../fields/dateField'
import TimeField from '../fields/timeField'
import CountDownField from '../fields/countDownField'
import MerchantTypeField from '../fields/MerchantTypeField'
import DealEndMessage from '../fields/DealEndField'

import SpecialDealActions from '../../../reducers/specialDealReducer'

class NewSpecialDealForm extends React.PureComponent {
  btnSubmitRef = React.createRef()

  state = {
    titleEn: '',
    titleKh: '',
    startAt: Date.now(),
    endAt: Date.now(),
    startTime: Date.now(),
    endTime: Date.now(),
    countdown: false,
    saving: false,
    merchantType: 'f-and-b',
    dealEndMessage: '',
  }

  componentDidMount() {
    const { action, specialDeal } = this.props

    if (action === 'edit') {
      this.setState({
        titleEn: specialDeal.title_en,
        titleKh: specialDeal.title_kh,
        startAt: specialDeal.started_at || Date.now(),
        endAt: specialDeal.ended_at || Date.now(),
        startTime: specialDeal.started_at || Date.now(),
        endTime: specialDeal.ended_at || Date.now(),
        countdown: specialDeal.countdown,
        merchantType: specialDeal.merchant_type,
        dealEndMessage: specialDeal.deal_end_message,
      })
    }
  }

  mergeDateTime = (date, time) => {
    const stringOfDate = moment(date).format('YYYY-MM-DD')
    const stringOfTime = moment(time).format('hh:mm A')
    const result = `${stringOfDate} ${stringOfTime}`

    return Number(moment(result).format('x'))
  }

  getDaysArray = (start, end) => {
    const arr = []
    const currentDate = moment(start)
    const stopDate = moment(end)

    while (currentDate.isSameOrBefore(stopDate, 'day')) {
      arr.push(currentDate.format('DD-MM-YYYY'))
      currentDate.add(1, 'days')
    }

    return arr
  }

  onSavePress = async () => {
    const { titleEn, titleKh, startAt, endAt, countdown, startTime, endTime, merchantType, dealEndMessage } = this.state
    const { saveSpecialDeal, onClose, action, specialDeal, authData } = this.props

    this.setState({ saving: true })

    const specialDealRef = firebase.firestore().collection('special_deals')
    const specialDealKey = (specialDeal && specialDeal.key) || specialDealRef.doc().id

    const data = {
      title_en: titleEn,
      title_kh: titleKh,
      started_at: this.mergeDateTime(startAt, startTime),
      ended_at: this.mergeDateTime(endAt, endTime),
      countdown,
      merchant_type: merchantType,
      deal_end_message: dealEndMessage || null,
      region: authData.region,
      days: this.getDaysArray(startAt, endAt),
    }

    if (action === 'edit') {
      await specialDealRef.doc(specialDealKey).update(data)
    } else {
      await specialDealRef.doc(specialDealKey).set(data)
    }

    this.setState({ saving: false })
    saveSpecialDeal({ ...data, key: specialDealKey })
    onClose()
  }

  render() {
    const { titleEn, titleKh, startAt, endAt, countdown, saving, startTime, endTime, merchantType, dealEndMessage } = this.state
    const { action, onClose } = this.props

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content={action === 'edit' ? 'Edit Special Deal' : 'Add New Special Deal'} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form onSubmit={this.onSavePress}>
            <Form.Group widths="equal">
              <TitleField
                label="Title in English"
                value={titleEn}
                onChange={value => this.setState({ titleEn: value })}
              />
              <TitleField
                label="Title in Khmer"
                value={titleKh}
                onChange={value => this.setState({ titleKh: value })}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <CountDownField value={countdown} onChange={value => this.setState({ countdown: value })} />
              <MerchantTypeField value={merchantType} onChange={value => this.setState({ merchantType: value })} />
            </Form.Group>

            <Form.Group widths="equal">
              <DateField
                label="Start Date"
                value={startAt}
                onChange={value =>
                  this.setState({
                    startAt: Number(
                      moment(value, 'YYYY-MM-DD')
                        .endOf('day')
                        .format('x')
                    ),
                  })
                }
              />
              <TimeField
                label="Start Time"
                value={startTime}
                onChange={value => this.setState({ startTime: Number(value.format('x')) })}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <DateField
                label="End Date"
                value={endAt}
                onChange={value =>
                  this.setState({
                    endAt: Number(
                      moment(value, 'YYYY-MM-DD')
                        .endOf('day')
                        .format('x')
                    ),
                  })
                }
              />
              <TimeField
                label="End Time"
                value={endTime}
                onChange={value => this.setState({ endTime: Number(value.format('x')) })}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <DealEndMessage value={dealEndMessage} onChange={value => this.setState({ dealEndMessage: value })} />
            </Form.Group>

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Close</Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={saving}
            disabled={saving}
          >
            <Icon name="checkmark" /> {action === 'new' ? 'Save' : 'Update'}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ auth }) => ({
  authData: auth.data,
})

const mapDispatch = {
  saveSpecialDeal: SpecialDealActions.saveSpecialDeal,
}

export default connect(
  mapState,
  mapDispatch
)(NewSpecialDealForm)



// WEBPACK FOOTER //
// ./src/components/specialDeal/forms/newSpecialDealForm.js